export enum Provider {
	VIMEO = 'vimeo',
	CLOUDFLARE_STREAM = 'cloudflare',
}

export interface PlayerOptions {
	externalIcons?: {play: string; pause: string};
	autoplay?: boolean;
	muted?: boolean;
	vimeo?: {autoplay?: boolean; controls?: boolean};
	cloudflare?: {controls?: boolean};
}

export interface IVideoProps {
	provider?: Provider;
	id: string;
	iframe?: string;
	options?: PlayerOptions;
	adaptToContainer?: boolean;
}
